(function () {
	'use strict';

	/**
	 * Pop-up de Reyes en los contenidos de Marruecos.
	 *
	 * Sale al segundo. Al cerrarlo —o al pulsar la imagen, que abre la landing en
	 * otra pestaña— se guarda la fecha y no vuelve a salir en `data-dias` días. Si el
	 * navegador no deja guardar (modo privado, almacenamiento bloqueado), sale
	 * igual: es preferible a no enseñarlo nunca.
	 */
	var CLAVE = 'bexReyesPopupCerrado';
	var RETRASO = 1000;

	var popup = document.getElementById('reyes-popup');
	if (!popup) {
		return;
	}

	var dias = parseInt(popup.getAttribute('data-dias'), 10) || 7;
	var img = popup.querySelector('img');
	var cerrar = popup.querySelector('.reyes-popup__cerrar');
	var enlace = popup.querySelector('.reyes-popup__enlace');
	var focoPrevio = null;

	function cerradoHace() {
		try {
			var cuando = parseInt(window.localStorage.getItem(CLAVE), 10);
			return cuando ? Date.now() - cuando : null;
		} catch (e) {
			return null;
		}
	}

	function recordar() {
		try {
			window.localStorage.setItem(CLAVE, String(Date.now()));
		} catch (e) {
			// sin almacenamiento, volverá a salir en la próxima página
		}
	}

	function abrir() {
		focoPrevio = document.activeElement;
		popup.hidden = false;
		document.documentElement.classList.add('reyes-popup-abierto');
		// Un frame para que la transición de opacidad arranque desde 0.
		window.requestAnimationFrame(function () {
			popup.classList.add('is-open');
		});
		cerrar.focus();
		document.addEventListener('keydown', teclado);
	}

	function ocultar() {
		recordar();
		popup.classList.remove('is-open');
		popup.hidden = true;
		document.documentElement.classList.remove('reyes-popup-abierto');
		document.removeEventListener('keydown', teclado);
		if (focoPrevio && focoPrevio.focus) {
			focoPrevio.focus();
		}
	}

	// Escape cierra; Tab no sale del pop-up (solo hay dos elementos con foco).
	function teclado(e) {
		if (e.key === 'Escape') {
			ocultar();
		} else if (e.key === 'Tab') {
			e.preventDefault();
			(document.activeElement === cerrar ? enlace : cerrar).focus();
		}
	}

	popup.querySelectorAll('[data-reyes-popup-cerrar]').forEach(function (el) {
		el.addEventListener('click', ocultar);
	});
	// La landing se abre en otra pestaña: esta se queda debajo y el pop-up se cierra.
	enlace.addEventListener('click', ocultar);

	var hace = cerradoHace();
	if (hace !== null && hace < dias * 864e5) {
		return;
	}

	// La imagen va con loading="lazy" para que quien ya lo cerró no la
	// descargue. Aquí se pide y se espera a tenerla, para no abrir una caja vacía.
	window.setTimeout(function () {
		img.loading = 'eager';
		var lista = img.decode ? img.decode() : Promise.resolve();
		lista.then(abrir, abrir);
	}, RETRASO);
})();
